// @flow
import * as React from 'react'
import { styled } from 'mz-ui-kit'
import { FormattedMessage } from 'mz-intl'
import moment from 'moment'
import parseFlightQuery from '../utils/parseFlightQuery'
import Button from '../../../core/Button'
import {
  Container,
  Message,
  ButtonContainer,
  SelectContainer,
} from '../../SelectField/EmptySearchResults/elements'
import NoFlightsFoundMessage from '../NoFlightsFoundMessage'
import messages from '../messages.intl'

// Types
import type { FlightInfo } from '../BasicFlightField'
import type { Flight } from 'mz-sdk/services/flights/getFlights'

type Props = {
  query?: ?string,
  flightInfo: FlightInfo,
  emptyResult?: boolean,
  onOpenFinder: ?() => any,
  onSelectFlight?: (Flight) => any,
}

// Utils
const preventDefault = (e) => e.preventDefault()

const ButtonWrapper = styled('div', {
  marginRight: '1rem',
})

const AdvancedSearchTip = (props: Props) => {
  const { query, emptyResult, onOpenFinder, onSelectFlight, flightInfo } = props
  const flightData = query ? parseFlightQuery(query) : null
  const hasFlightData = flightData?.flightNumber && flightData?.airlineCode
  const emptyResultMessage = hasFlightData ? (
    <NoFlightsFoundMessage flightInfo={flightInfo} />
  ) : (
    <FormattedMessage message={messages.INCORRECT_FLIGHT_NUMBER} />
  )

  function handleSelectNonexistingFlight() {
    if (!flightData || !onSelectFlight) return
    const {
      airportCode,
      flightDirection,
      pickupDatetime,
      flightDatetime,
    } = flightInfo

    const parsedPickupDatetime = moment.parseZone(
      flightDatetime || pickupDatetime
    )
    const flightTime = parsedPickupDatetime.format('hh:mmA')
    const sources =
      flightDirection === 'dep'
        ? { origin: airportCode, destination: '' }
        : { origin: '', destination: airportCode }

    onSelectFlight({
      ...sources,
      flightNumber: flightData?.flightNumber || '',
      flightCode: `${flightData?.airlineCode || ''}${
        flightData?.flightNumber || ''
      }`,
      airlineCode: flightData?.airlineCode,
      airlineName: flightData?.airlineCode,
      time: flightTime,
      flightDatetime: parsedPickupDatetime,
    })
  }

  return (
    <Container onMouseDown={preventDefault}>
      {emptyResult && <Message>{emptyResultMessage}</Message>}
      <SelectContainer>
        <div>
          <Message>
            <FormattedMessage message={messages.CANT_FIND_FLIGHT_OPTION} />
          </Message>
          <ButtonContainer>
            <ButtonWrapper>
              <Button
                tabIndex="-1"
                appearance="outlined"
                onClick={onOpenFinder}
              >
                <FormattedMessage message={messages.ADVANCED_SEARCH_TIP} />
              </Button>
            </ButtonWrapper>
            {hasFlightData && (
              <Button
                tabIndex="-1"
                appearance="outlined"
                onClick={handleSelectNonexistingFlight}
              >
                <FormattedMessage
                  message={messages.SELECT_TYPED_FLIGHT}
                  values={{
                    flight: `${flightData?.airlineCode || ''} ${
                      flightData?.flightNumber || ''
                    }`,
                  }}
                />
              </Button>
            )}
          </ButtonContainer>
        </div>
      </SelectContainer>
    </Container>
  )
}

export default AdvancedSearchTip
